<div class="fixed inset-0 z-[1003] bg-white">
  <div class="relative h-full w-full">
    <div class="h-full w-full">
      <div class="flex h-full w-full items-center justify-center p-4">
        @if (imageSrc) {
          <app-svg [url]="imageSrc" [withZoom]="true" [padding]="50" class="block h-full w-full" />
        }
      </div>
    </div>

    <app-modal-buttons
      [showPrintButton]="true"
      [showCloseButton]="true"
      (closeClick)="close()"
      class="!absolute right-2 top-4 md:right-6 md:top-6 print:hidden" />
  </div>
</div>
